import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import type { JSX } from 'react';
import TabMode from '../Enums/TabMode';
import OrdersTab from '../Tabs/OrdersTab/OrdersTab';
import SettingsTab from '../Tabs/SettingsTab/SettingsTab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faGear } from '@fortawesome/free-solid-svg-icons';
import { updateLastActivity } from '../Utils/LastActivity';
import type { UserContextProps } from '../Contexts/UserContext';
import UserContext from '../Contexts/UserContext';
import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import LocalStorageContext from '../Contexts/LocalStorageContext';
import { navBarHeight } from '../Constants';
import type { NavigateFunction} from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';

type MainPageProps = {
    tabMode: TabMode,
    subView: string | null,
};

function MainPage(props: Readonly<MainPageProps>): JSX.Element {

    const userContext: UserContextProps = useContext<UserContextProps>(UserContext);
    const localStorageContext: LocalStorageContextProps = useContext<LocalStorageContextProps>(LocalStorageContext);

    const navigate: NavigateFunction = useNavigate();

    const { orderId } = useParams(); //dynamic id from url

    const [windowSize, setWindowSize] = useState<[number, number]>([1920, 1080]);

    const mainRenderBody: JSX.Element = useMemo<JSX.Element>(() => {

        if (props.tabMode === TabMode.ORDERS) {
            return <OrdersTab openedOrderId={orderId ?? null} />; 

        } else if (props.tabMode === TabMode.SETTINGS) {
            return <SettingsTab openedSubTab={props.subView} />; 

        } else { //should not happen
            return <OrdersTab openedOrderId={null} />;
        }
    }, [orderId, props.subView, props.tabMode]);

    const bottonNavigationValue: string = useMemo<string>(() => {

        if (props.tabMode === TabMode.ORDERS) {
            return '/orders'; 

        } else if (props.tabMode === TabMode.SETTINGS) {
            return '/settings'; 

        } else { //should not happen
            return '/orders';
        }
    }, [props.tabMode]);

    useEffect(() => {

        function updateSize(): void {
            setWindowSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div>
            <div style={{
                height: windowSize[1] - navBarHeight,
                overflow: 'auto',
            }}>
                {mainRenderBody}
            </div>
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={bottonNavigationValue}
                    onChange={(event: React.SyntheticEvent, newRoute: string): void => {
                        updateLastActivity(userContext, localStorageContext);
                        navigate(newRoute);
                    }}
                    style={{
                        height: navBarHeight,
                    }}
                >
                    <BottomNavigationAction value={'/orders'} label='Orders' icon={<FontAwesomeIcon icon={faFileInvoice} size='xl' />} />
                    <BottomNavigationAction value={'/settings'} label='Settings' icon={<FontAwesomeIcon icon={faGear} size='xl' />} />
                </BottomNavigation>
            </Paper>
        </div>
    );
}

export default MainPage;
